import React, { useState } from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Wifi, Globe, Signal, Download, Upload, Clock, CreditCard, AlertCircle } from 'lucide-react';
import { Button } from '../Button';
import { RechargeModal } from './RechargeModal';
export function Dashboard() {
  const [isRechargeModalOpen, setIsRechargeModalOpen] = useState(false);
  const [selectedEsim, setSelectedEsim] = useState(null);
  const activeEsims = [{
    id: 1,
    country: 'Turkey',
    flag: '🇹🇷',
    dataLeft: '3.2 GB',
    validUntil: '2024-02-20',
    status: 'active'
  }, {
    id: 2,
    country: 'UAE',
    flag: '🇦🇪',
    dataLeft: '1.5 GB',
    validUntil: '2024-02-15',
    status: 'expiring'
  }];
  const recentTransactions = [{
    id: 1,
    type: 'Purchase',
    amount: '$19.99',
    date: '2024-01-15',
    status: 'completed'
  }, {
    id: 2,
    type: 'Top-up',
    amount: '$9.99',
    date: '2024-01-10',
    status: 'completed'
  }];
  const handleRecharge = esim => {
    setSelectedEsim(esim);
    setIsRechargeModalOpen(true);
  };
  return <DashboardLayout onRechargeClick={() => setIsRechargeModalOpen(true)} data-id="element-109">
      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-110">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-111">
          <div className="flex items-center justify-between mb-4" data-id="element-112">
            <Wifi className="h-6 w-6 text-blue-500" data-id="element-113" />
            <span className="text-sm text-gray-500" data-id="element-114">Active eSIMs</span>
          </div>
          <p className="text-2xl font-bold" data-id="element-115">2</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-116">
          <div className="flex items-center justify-between mb-4" data-id="element-117">
            <Globe className="h-6 w-6 text-green-500" data-id="element-118" />
            <span className="text-sm text-gray-500" data-id="element-119">Countries Visited</span>
          </div>
          <p className="text-2xl font-bold" data-id="element-120">5</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-121">
          <div className="flex items-center justify-between mb-4" data-id="element-122">
            <Signal className="h-6 w-6 text-purple-500" data-id="element-123" />
            <span className="text-sm text-gray-500" data-id="element-124">Data Used</span>
          </div>
          <p className="text-2xl font-bold" data-id="element-125">25.4 GB</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-126">
          <div className="flex items-center justify-between mb-4" data-id="element-127">
            <CreditCard className="h-6 w-6 text-orange-500" data-id="element-128" />
            <span className="text-sm text-gray-500" data-id="element-129">Total Spent</span>
          </div>
          <p className="text-2xl font-bold" data-id="element-130">$89.95</p>
        </div>
      </div>
      {/* Active eSIMs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-8" data-id="element-131">
        <div className="p-6 border-b border-gray-100" data-id="element-132">
          <h2 className="text-lg font-bold" data-id="element-133">Active eSIMs</h2>
        </div>
        <div className="p-6" data-id="element-134">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-135">
            {activeEsims.map(esim => <div key={esim.id} className="border border-gray-200 rounded-xl p-6" data-id="element-136">
                <div className="flex items-center justify-between mb-4" data-id="element-137">
                  <div className="flex items-center" data-id="element-138">
                    <span className="text-2xl mr-3" data-id="element-139">{esim.flag}</span>
                    <div data-id="element-140">
                      <h3 className="font-semibold" data-id="element-141">{esim.country}</h3>
                      <p className="text-sm text-gray-500" data-id="element-142">
                        Valid until {esim.validUntil}
                      </p>
                    </div>
                  </div>
                  <div className={`px-3 py-1 rounded-full text-sm ${esim.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-143">
                    {esim.status}
                  </div>
                </div>
                <div className="flex items-center justify-between mb-4" data-id="element-144">
                  <div className="flex items-center" data-id="element-145">
                    <Signal className="h-5 w-5 text-blue-500 mr-2" data-id="element-146" />
                    <span className="text-sm text-gray-600" data-id="element-147">Data Left</span>
                  </div>
                  <span className="font-semibold" data-id="element-148">{esim.dataLeft}</span>
                </div>
                <Button variant="outline" fullWidth onClick={() => handleRecharge(esim)} data-id="element-149">
                  Top Up Data
                </Button>
              </div>)}
          </div>
        </div>
      </div>
      {/* Usage Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-150">
        {/* Data Usage */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-151">
          <div className="p-6 border-b border-gray-100" data-id="element-152">
            <h2 className="text-lg font-bold" data-id="element-153">Data Usage</h2>
          </div>
          <div className="p-6" data-id="element-154">
            <div className="space-y-4" data-id="element-155">
              <div className="flex items-center justify-between" data-id="element-156">
                <div className="flex items-center" data-id="element-157">
                  <Download className="h-5 w-5 text-blue-500 mr-2" data-id="element-158" />
                  <span data-id="element-159">Download</span>
                </div>
                <span className="font-semibold" data-id="element-160">18.3 GB</span>
              </div>
              <div className="flex items-center justify-between" data-id="element-161">
                <div className="flex items-center" data-id="element-162">
                  <Upload className="h-5 w-5 text-green-500 mr-2" data-id="element-163" />
                  <span data-id="element-164">Upload</span>
                </div>
                <span className="font-semibold" data-id="element-165">7.1 GB</span>
              </div>
            </div>
          </div>
        </div>
        {/* Recent Transactions */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-166">
          <div className="p-6 border-b border-gray-100" data-id="element-167">
            <h2 className="text-lg font-bold" data-id="element-168">Recent Transactions</h2>
          </div>
          <div className="p-6" data-id="element-169">
            <div className="space-y-4" data-id="element-170">
              {recentTransactions.map(transaction => <div key={transaction.id} className="flex items-center justify-between" data-id="element-171">
                  <div className="flex items-center" data-id="element-172">
                    <Clock className="h-5 w-5 text-gray-400 mr-2" data-id="element-173" />
                    <div data-id="element-174">
                      <p className="font-medium" data-id="element-175">{transaction.type}</p>
                      <p className="text-sm text-gray-500" data-id="element-176">
                        {transaction.date}
                      </p>
                    </div>
                  </div>
                  <span className="font-semibold" data-id="element-177">{transaction.amount}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {/* Support Section */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white" data-id="element-178">
        <div className="flex items-start space-x-4" data-id="element-179">
          <div className="p-3 bg-white/10 rounded-lg" data-id="element-180">
            <AlertCircle className="h-6 w-6" data-id="element-181" />
          </div>
          <div data-id="element-182">
            <h3 className="font-semibold mb-1" data-id="element-183">Need Help?</h3>
            <p className="text-blue-100 mb-4" data-id="element-184">
              Our support team is available 24/7 to assist you with any
              questions.
            </p>
            <Button variant="outline" className="bg-white text-blue-600" data-id="element-185">
              Contact Support
            </Button>
          </div>
        </div>
      </div>
      <RechargeModal isOpen={isRechargeModalOpen} onClose={() => setIsRechargeModalOpen(false)} esimDetails={selectedEsim} data-id="element-186" />
    </DashboardLayout>;
}